module.exports = __webpack_public_path__ + "assets/img/tq.d559011d.png";